const LocationOutlineIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <mask
        id="mask0_1827_28405"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1827_28405)">
        <path
          d="M9.99992 16.1248C11.6944 14.5693 12.9513 13.1561 13.7708 11.8853C14.5902 10.6144 14.9999 9.48595 14.9999 8.49984C14.9999 6.98595 14.5173 5.74637 13.552 4.78109C12.5867 3.81581 11.4027 3.33317 9.99992 3.33317C8.59714 3.33317 7.41311 3.81581 6.44784 4.78109C5.48256 5.74637 4.99992 6.98595 4.99992 8.49984C4.99992 9.48595 5.40964 10.6144 6.22909 11.8853C7.04853 13.1561 8.30547 14.5693 9.99992 16.1248ZM9.99992 17.7707C9.80547 17.7707 9.61103 17.736 9.41659 17.6665C9.22214 17.5971 9.04853 17.4929 8.89575 17.354C7.99297 16.5207 7.19436 15.7082 6.49992 14.9165C5.80547 14.1248 5.22561 13.3575 4.76034 12.6144C4.29506 11.8714 3.94089 11.1561 3.69784 10.4686C3.45478 9.78109 3.33325 9.12484 3.33325 8.49984C3.33325 6.4165 4.00339 4.75678 5.34367 3.52067C6.68395 2.28456 8.23603 1.6665 9.99992 1.6665C11.7638 1.6665 13.3159 2.28456 14.6562 3.52067C15.9964 4.75678 16.6666 6.4165 16.6666 8.49984C16.6666 9.12484 16.5451 9.78109 16.302 10.4686C16.0589 11.1561 15.7048 11.8714 15.2395 12.6144C14.7742 13.3575 14.1944 14.1248 13.4999 14.9165C12.8055 15.7082 12.0069 16.5207 11.1041 17.354C10.9513 17.4929 10.7777 17.5971 10.5833 17.6665C10.3888 17.736 10.1944 17.7707 9.99992 17.7707ZM9.99992 9.99984C10.4583 9.99984 10.8506 9.83664 11.177 9.51025C11.5034 9.18387 11.6666 8.7915 11.6666 8.33317C11.6666 7.87484 11.5034 7.48248 11.177 7.15609C10.8506 6.8297 10.4583 6.6665 9.99992 6.6665C9.54158 6.6665 9.14922 6.8297 8.82284 7.15609C8.49645 7.48248 8.33325 7.87484 8.33325 8.33317C8.33325 8.7915 8.49645 9.18387 8.82284 9.51025C9.14922 9.83664 9.54158 9.99984 9.99992 9.99984Z"
          fill="#969696"
        />
      </g>
    </svg>
  );
};

export default LocationOutlineIcon;
